// extracted by mini-css-extract-plugin
export var buttonLeft = "CustomTestimonials-module--buttonLeft--85795";
export var buttonRight = "CustomTestimonials-module--buttonRight--3779e";
export var container = "CustomTestimonials-module--container--32534";
export var fadeInAnimation = "CustomTestimonials-module--fadeInAnimation--21389";
export var sliderContainer = "CustomTestimonials-module--sliderContainer--ae22c";
export var sliderControls = "CustomTestimonials-module--sliderControls--41855";
export var topRow = "CustomTestimonials-module--topRow--dd44e";
export var wrapper = "CustomTestimonials-module--wrapper--aef39";